var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0521 7.08537L20.1 7.05614V7C20.1 6.70826 19.9841 6.42847 19.7778 6.22218C19.5715 6.01589 19.2917 5.9 19 5.9H5C4.70826 5.9 4.42847 6.01589 4.22218 6.22218C4.01589 6.42847 3.9 6.70826 3.9 7V7.05614L3.94792 7.08537L11.9479 11.9654L12 11.9971L12.0521 11.9654L20.0521 7.08537ZM4.05214 9.19467L3.9 9.10172V9.28V17C3.9 17.2917 4.01589 17.5715 4.22218 17.7778C4.42847 17.9841 4.70826 18.1 5 18.1H19C19.2917 18.1 19.5715 17.9841 19.7778 17.7778C19.9841 17.5715 20.1 17.2917 20.1 17V9.28V9.10221L19.9481 9.19454L12.43 13.7634C12.4297 13.7636 12.4294 13.7638 12.4291 13.7639C12.2925 13.8426 12.1376 13.884 11.98 13.884C11.8224 13.884 11.6676 13.8426 11.531 13.764L4.05214 9.19467ZM5 4.1H19C19.7691 4.1 20.5068 4.40553 21.0506 4.94939C21.5945 5.49325 21.9 6.23087 21.9 7V17C21.9 17.7691 21.5945 18.5068 21.0506 19.0506C20.5068 19.5945 19.7691 19.9 19 19.9H5C4.23087 19.9 3.49325 19.5945 2.94939 19.0506C2.40553 18.5068 2.1 17.7691 2.1 17V7C2.1 6.23087 2.40553 5.49325 2.94939 4.94939C3.49325 4.40553 4.23087 4.1 5 4.1Z",
    fill: "#DDE2E5",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c81a0c5e.svg";
export { ForwardRef as ReactComponent };